<template>
  <!-- biome-ignore lint/a11y/useMediaCaption: visitors upload these films, so there are no captions to show -->
  <video
    controls
    loop
    playsinline
    ref="video"
    :autoplay="autoplay"
    :poster="video.thumbnail"
  >
    <source
      type="video/webm"
      v-if="video.webm"
      :src="`${imgIxDomain}${video.webm}`"
    >
    <source type="video/mp4" :src="`${imgIxDomain}${video.mp4}`">
    <p>
      {{ texts.videoNotSupported }}
      <a
        :download="`${imgIxDomain}${video.mp4}`"
        :href="`${imgIxDomain}${video.mp4}`"
      >
        {{ texts.downloadVideo }}
      </a>
    </p>
  </video>
</template>
<script>
  export default {
    data() {
      return {
        imgIxDomain: `https://${lavendlaObituary.imgIxDomain}/`,
        texts: lavendlaObituary.common,
      };
    },

    methods: {
      pause() {
        this.$refs.video.pause();
      },
    },
    name: "ImgixVideo",

    props: {
      autoplay: {
        default: true,
        type: Boolean,
      },
      video: {
        required: true,
        type: Object,
      },
    },
  };
</script>

<style scoped>
  video {
    width: auto;
    height: auto;
    max-height: 100%;
  }
</style>
